/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KinnserPatientMatch } from './KinnserPatientMatch';
import {
    KinnserPatientMatchFromJSON,
    KinnserPatientMatchFromJSONTyped,
    KinnserPatientMatchToJSON,
    KinnserPatientMatchToJSONTyped,
} from './KinnserPatientMatch';

/**
 * 
 * @export
 * @interface KinnserPatientSearchResult
 */
export interface KinnserPatientSearchResult {
    /**
     * 
     */
    clinic_key: string;
    /**
     * 
     */
    matches: Array<KinnserPatientMatch>;
}

/**
 * Check if a given object implements the KinnserPatientSearchResult interface.
 */
export function instanceOfKinnserPatientSearchResult(value: object): value is KinnserPatientSearchResult {
    if (!('clinic_key' in value) || value['clinic_key'] === undefined) return false;
    if (!('matches' in value) || value['matches'] === undefined) return false;
    return true;
}

export function KinnserPatientSearchResultFromJSON(json: any): KinnserPatientSearchResult {
    return KinnserPatientSearchResultFromJSONTyped(json, false);
}

export function KinnserPatientSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): KinnserPatientSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'clinic_key': json['clinic_key'],
        'matches': ((json['matches'] as Array<any>).map(KinnserPatientMatchFromJSON)),
    };
}

export function KinnserPatientSearchResultToJSON(json: any): KinnserPatientSearchResult {
    return KinnserPatientSearchResultToJSONTyped(json, false);
}

export function KinnserPatientSearchResultToJSONTyped(value?: KinnserPatientSearchResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clinic_key': value['clinic_key'],
        'matches': ((value['matches'] as Array<any>).map(KinnserPatientMatchToJSON)),
    };
}

